import { VueModule } from '@Foundation/utilities';
import LrpRetailer from './code/Scripts/components/lrp-retailer.vue';

export default VueModule({
  components: {
    LrpRetailer
  }
});
